import { defaultOctaveMidiNote, noteToName } from "components/utils/helpers"

class Scales {
  constructor() {
    this.scales = {
      chromatic       : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      maj             : [0, 2, 4, 5, 7, 9, 11], //diatonic
      min             : [0, 2, 3, 5, 7, 8, 10], //aeolian
      min_penta       : [0, 3, 5, 7, 10],
      maj_penta       : [0, 2, 4, 7, 9],
      dorian          : [0, 2, 3, 5, 7, 9, 10],
      phrygian        : [0, 1, 3, 5, 7, 8, 10],
      lydian          : [0, 2, 4, 6, 7, 9, 11],
      mixolydian      : [0, 2, 4, 5, 7, 9, 0],
      locrian         : [0, 1, 3, 5, 6, 8, 10],
      harmonic_minor  : [0, 2, 3, 5, 7, 8, 11],
      melodic_minor   : [0, 2, 3, 5, 7, 9, 11],
      double_harmonic : [0, 1, 4, 5, 7, 8, 11], //arabic
      half_dim        : [0, 2, 3, 5, 6, 8, 10], //Locrian ♮2
      altered         : [0, 1, 3, 4, 6, 8, 10], //superlocrian
      wholetone       : [0, 2, 4, 6, 8, 10],
    };
  }
  getNote(scale, root, step) {
    const idWrapped = step % this.scales[scale].length;
    const octave = Math.floor(step / this.scales[scale].length);
    return noteToName(defaultOctaveMidiNote + root + this.scales[scale][idWrapped] + (octave * 12));
  }
}

const instance = new Scales();
Object.freeze(instance);

export default instance;
